var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTickCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.6663 2.66667V6.66667M9.33301 2.66667V6.66667",
    stroke: "#3498DB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3333 4.66667H14.6667C9.63835 4.66667 7.1242 4.66667 5.56209 6.22876C4 7.79087 4 10.305 4 15.3333V18.6667C4 23.6949 4 26.2092 5.56209 27.7712C7.1242 29.3333 9.63835 29.3333 14.6667 29.3333H17.3333C22.3616 29.3333 24.8759 29.3333 26.4379 27.7712C28 26.2092 28 23.6949 28 18.6667V15.3333C28 10.305 28 7.79087 26.4379 6.22876C24.8759 4.66667 22.3616 4.66667 17.3333 4.66667Z",
    stroke: "#3498DB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.66699 11.3333H27.3337",
    stroke: "#3498DB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 20.6667C12 20.6667 14 21.3333 14.6667 23.3333C14.6667 23.3333 17.5687 18 21.3333 16.6667",
    stroke: "#3498DB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickCalendar);
export default __webpack_public_path__ + "static/media/tick-calendar.4fc210fa5f215c7d0a177602a22cf650.svg";
export { ForwardRef as ReactComponent };